import { comparerByAlphabet } from '@app/comparers';
import { Brand } from '@app/models';

import {
  BrandActionsUnion,
  BrandActionTypes
} from '@core/actions/brand.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { BrandsPageComponent } from '@app/modules/brands/containers/brands-page/brands-page.component';

export interface State extends EntityState<Brand> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<Brand> = createEntityAdapter<Brand>({
  selectId: (brand: Brand) => brand.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: BrandActionsUnion
) {
  switch (action.type) {
    case BrandActionTypes.Load:
      return { ...state, loading: true };

    case BrandActionTypes.LoadFail:
      return { ...state, loading: false };

    case BrandActionTypes.LoadSuccess:
      return adapter.addAll(action.brands, {
        ...state,
        loading: false,
        loaded: true
      });

    case BrandActionTypes.AddPicture: {
      const id = action.file.BrandId;
      const item = state.entities[id];
      if (item) {
        const pictures = [action.file, ...item.Pictures];
        return adapter.updateOne(
          { id, changes: { Pictures: pictures } },
          state
        );
      } else {
        return state;
      }
    }

    case BrandActionTypes.AddOne:
      return adapter.addOne(action.brand, state);

    default:
      return state;

    case BrandActionTypes.UpdateBrand:
      return adapter.updateOne({ id: action.id, changes: action.brand }, state);
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
